import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastElement',
})
export class LastElementPipe implements PipeTransform {
  public transform(value: any[], ...args: unknown[]): any {
    return value[value.length - 1];
  }
}
